import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { roleSelector } from '../../store/login';
import config from '../../config/config.json';

const RouteWithLayout = props => {
  const { layout: Layout, component: Component, ...rest } = props;
  const userRole = useSelector(roleSelector);

  if (props.roles) {
    if (props.roles.indexOf(userRole) === -1) {
      // Если не авторизован то на логин
      return <Redirect to="/not-found" />;
    }
  }

  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default RouteWithLayout;
